/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DTOCurrentSalary from './DTOCurrentSalary';
import CurrentSalaryPresenter from './CurrentSalaryPresenter';
import { useAppSelector } from '../../../../infra/hooks';
import { useTranslation } from 'react-i18next';
function CurrentSalaryController() {
  const { t } = useTranslation();
  const [allowancesData, setAllowancesData] = useState<any>([]);
  const [additionalBenefits, setAdditionalBenefits] = useState<any>([]);
  const [netSalary, setNetSalary] = useState(0);
  const [startDate, setStartDate] = useState('');
  const [currentCurrency, setCurrentCurrency] = useState<string>('');

  const isLoading = useAppSelector(
    (state) => state.salaryLoadersSlice.currentSalaryLoader,
  );
  function callBackAdditionalBenefits(data: any) {
    setAdditionalBenefits(data);
  }
  function callBackAllowances(data: any) {
    setAllowancesData(data);
  }
  function getTotalNetSalary(data: any) {
    setNetSalary(data);
  }
  function getStartDate(data: any) {
    setStartDate(data);
  }
  function getCurrency(data: string) {
    setCurrentCurrency(data);
  }

  return (
    <>
      <DTOCurrentSalary
        setAllEmpAdditionalBenefits={callBackAdditionalBenefits}
        setAllEmpAllowances={callBackAllowances}
        setTotalNetSalary={getTotalNetSalary}
        setStartDate={getStartDate}
        setCurrency={getCurrency}
      />
      <CurrentSalaryPresenter
        allAllowancesData={allowancesData}
        allAdditionalBenefitsData={additionalBenefits}
        totalNetSalary={netSalary}
        salaryStartDate={startDate}
        currentCurrency={currentCurrency}
        isLoading={isLoading}
        trans={t}
      />
    </>
  );
}

export default CurrentSalaryController;
